import * as THREE from "three";
import { BufferGeometry, Line, Line3, MathUtils, Ray, Vector3 } from "three";
import { generateUUID } from "three/src/math/MathUtils";
import { ArcDimension } from "@/Dimensions/ArcDimension";
import { LineDimension } from "@/Dimensions/LineDimension";
import { IndserObject, IndsertPosition } from "@/core/IndserObject";
import { MLayer } from "@/core/MLayer";
import {
  DBEntity,
  DbLayer,
  DbLine,
  FMathUtils,
  ModelManager,
  ViewManager,
} from "@/CadEngine";
import { BPMathUtils } from "@/utils/BPMathUtils";
import {
  DrawOperateState,
  IDrawOperation,
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
} from "./IDrawOperation";
import { AnchorPointAux } from "@/Dimensions/AnchorPointAuxs";
import { BPLinear } from "@/core/BPLinear";
import { OrthogonalAux } from "@/Dimensions/OrthogonalAux";
import { UInput } from "../ui/UInput";
import {
  CommonColor,
  DrawOperateLineParams,
  EllipseArcReturnData,
} from "@/core/Parameters";
class DrawOperationEllipseArc implements IDrawOperation {
  private m_model: ModelManager;
  private m_layer: DbLayer;
  private m_auxLayer: MLayer;
  private m_material: THREE.LineBasicMaterial;
  private m_tempObject: THREE.Line | undefined;
  private m_auxGeometry: THREE.BufferGeometry | undefined;
  private points: THREE.Vector3[] = [];
  private m_locationObject: THREE.Line;
  private m_size = { x: 1, y: 1, z: 1 };
  private view: ViewManager;
  private m_dimension: DimensionGroup;
  private inputValue: string = "";
  private m_auxPoints: {
    orgin: THREE.Vector3;
    dir: THREE.Vector3 | undefined;
  }[] = [];
  private m_preMovePoint: { point: THREE.Vector3; time: number } = {
    point: new THREE.Vector3(),
    time: 0,
  };
  private m_auxOrthogonalOrVertical:
    | { position: IndsertPosition; origin: THREE.Vector3; dir: THREE.Vector3 }
    | undefined;

  private canDrawCallBack: (params: DrawOperationMovePointParams) => boolean;
  private ellipseOriginRadius: number = 0;
  private isEllipseOrigin: boolean = true;
  constructor(
    options: DrawOperateLineParams,
    canDrawCallBack: (params: DrawOperationMovePointParams) => boolean
  ) {
    this.m_model = options.model;
    this.m_layer = options.layer;
    this.m_auxLayer = options.auxLayer;
    this.m_material = new THREE.LineBasicMaterial({
      color: new THREE.Color(options.layer.Color),
    });
    this.m_locationObject =
      options.view.m_context.ToolsManager.CreatedLocationLine();
    this.view = options.view;
    let scale = options.view.ScreenModelScale;
    this.m_dimension = new DimensionGroup(options.view, this.m_auxLayer);
    this.canDrawCallBack = canDrawCallBack;
    this.m_dimension.Line.SetVaule("");
    this.m_dimension.Arc.SetVaule("");
    this.createEllipse();
  }

  SetDrawLineForDashed() {
    this.m_material = new THREE.LineDashedMaterial({
      color: new THREE.Color(this.m_layer.Color),
      linewidth: 0.2,
      dashSize: 0.2,
      gapSize: 0.1,
    });
  }

  onMouseMove(e?: PointerEvent): void {
    if (this.points.length > 0) {
      this.isAllowInput = true;
      if (this.points.length === 2) {
        let subVec1 = new THREE.Vector3().subVectors(
          this.points[1],
          this.points[0]
        );
        subVec1.applyAxisAngle(new THREE.Vector3(0, 0, 1), Math.PI / 2);
        let distance = this.points[0].distanceTo(this.curPoint);
        if (this.isEnter) {
          distance = this.points[0].distanceTo(this.m_locationObject.position);
        }
        subVec1.setLength(distance);
        let newVector = subVec1.clone().add(this.points[0]);
        this.m_dimension.Line.SetDimension(
          this.points[0],
          newVector,
          this.scale
        );
        if (!this.isDrawEllipseEnd) {
          this.inputValue = (
            newVector.distanceTo(this.points[0]) * 1000
          ).toString();
        }
      } else {
        this.m_dimension.Line.SetDimension(
          this.originPoint,
          this.curPoint,
          this.scale
        );
        if (!this.isDrawEllipseEnd) {
          this.inputValue = (
            this.originPoint.distanceTo(this.curPoint) * 1000
          ).toString();
        }
      }
    }
    this.m_dimension.Anchor.SetPoint(this.auxPoint, this.scale);
  }
  private isLineInput: boolean = true;
  private angleNum: number | undefined;
  private isLineLength: boolean = false;
  private isLineAngle: boolean = false;
  private isAllowInput: boolean = false;
  private lineLengthInputValue: string = "";
  private isEnter: boolean = false;
  public isDrawEllipseArcEnd: boolean = false;
  private startEllipseArcRadian: number = 0;
  private endEllipseArcRadian: number = 0;

  onKeyDown(e: KeyboardEvent): void {
    this.m_auxPoints = [];
    if (this.isLineInput) {
      this.m_dimension.Line.Input.Dom.style.border = "2px solid #fff";
      this.m_dimension.Arc.Input.Dom.style.border = "1px solid #101010";
    }
    if (e.key === "Tab") {
      e.preventDefault();
      this.isAllowInput = true;
      this.isLineInput = !this.isLineInput;
      if (this.points.length < 2) {
        if (!this.isLineInput) {
          this.m_dimension.Arc.Input.Dom.style.border = "2px solid #fff";
          this.m_dimension.Line.Input.Dom.style.border = "1px solid #101010";
        } else {
          this.m_dimension.Line.Input.Dom.style.border = "2px solid #fff";
          this.m_dimension.Arc.Input.Dom.style.border = "1px solid #101010";
        }
      } else {
        this.isLineInput = true;
      }
    }

    if (e.key == "Backspace") {
      if (this.inputValue.length > 0) {
        this.inputValue = this.inputValue.substring(
          0,
          this.inputValue.length - 1
        );
        if (this.isLineInput) {
          this.m_dimension.Line.SetVaule(this.inputValue);
          this.lineLengthInputValue = this.inputValue;
        } else {
          this.m_dimension.Arc.SetVaule(this.inputValue);
        }
        if (this.isDrawEllipseEnd) {
          this.ellipseArcRotateInput?.SetVaule(this.inputValue);
        }
      }
    } else if ((e.key >= "0" && e.key <= "9") || e.key == ".") {
      if (this.inputValue?.includes(".") && e.key == ".") return;
      if (this.isAllowInput) {
        this.inputValue = "";
        this.isAllowInput = false;
      }
      this.inputValue += e.key;
      if (this.isLineInput) {
        this.isLineLength = true;
        this.m_dimension.Line.SetVaule(this.inputValue);
        this.lineLengthInputValue = this.inputValue;
      } else {
        this.m_dimension.Arc.SetVaule(this.inputValue);
        this.angleNum = Number(this.inputValue);
      }
      if (this.isDrawEllipseEnd) {
        this.ellipseArcRotateInput?.SetVaule(this.inputValue);
      }
      if (!this.isDrawEllipseEnd) {
        this.radius = Number(this.inputValue) / 1000;
      }
    } else if (e.key == "Enter") {
      if (this.isDrawEllipseEnd) {
        let subVec1 = new THREE.Vector3().subVectors(
          this.points[1],
          this.points[0]
        );
        if (Number(this.inputValue) > 360) {
          const decimalArray = (Number(this.inputValue) / 360)
            .toString()
            .split(".");
          // 获取小数点后面的数字部分
          const decimalPart = "0." + decimalArray[1];
          this.inputValue = (Number(decimalPart) * 360).toString();
        }

        let rad = THREE.MathUtils.degToRad(Number(this.inputValue) - 90);
        subVec1.applyAxisAngle(new THREE.Vector3(0, 0, 1), rad);
        let newVector = subVec1.clone().add(this.points[0]);
        let length = this.curPoint.distanceTo(this.points[0]);
        this.curPoint.copy(newVector);
        this.angleNum = Number(this.inputValue);
        if (!this.isUpdateEllipseArc) {
          this.drawEllipseArc();
          let subVec2 = new THREE.Vector3().subVectors(
            newVector,
            this.points[0]
          );
          subVec2.setLength(length);
          let newVector1 = subVec2.clone().add(this.points[0]);
          this.m_auxGeometry!.setFromPoints([this.points[0], newVector1]);
          let curPoint = newVector1.clone();
          curPoint.y -= 10;
          this.ellipseArcRotateInput?.SetVaule(
            this.inputValue,
            curPoint,
            this.points[0]
          );

          this.m_locationObject.position.copy(newVector1.clone());
          this.isUpdateEllipseArc = true;
        } else {
          // this.updateEllipseGeometry();
          this.updateEllipseArc();
          this.isDrawEllipseArcEnd = true;
        }
        return;
      }
      if (this.inputValue === "") {
        if (this.isLineInput) {
          this.inputValue = (
            this.originPoint.distanceTo(this.curPoint) * 1000
          ).toString();
        } else {
          this.inputValue = this.m_dimension.Arc.Input.Dom.value;
          this.angleNum = Number(this.inputValue);
        }
      }
      if (this.inputValue != "") {
        if (this.points.length > 0) {
          let length = parseFloat(this.inputValue) * 0.001;
          if (this.isLineLength) {
            length = parseFloat(this.lineLengthInputValue) * 0.001;
          }
          let position = this.m_locationObject.position.clone();
          let dir = this.points[this.points.length - 1]
            .clone()
            .sub(position)
            .normalize();
          position = this.points[this.points.length - 1]
            .clone()
            .add(dir.multiplyScalar(-length));
          this.points.push(position);
          if (this.angleNum === 0 || this.angleNum) {
            this.isLineAngle = true;
          } else {
            this.isLineAngle = false;
          }
          if (this.points.length == 2) {
            this.m_dimension.Arc.dispose();
            this.isEllipseOrigin = false;
          }
          this.isEnter = true;
          this.OnMovePoint({
            point: this.m_locationObject.position,
            geo: undefined,
            position: IndsertPosition.None,
          });
          this.onMouseMove();

          this.getRotateAngle();
          if (this.isLineInput) {
            if (this.points.length == 2) {
              this.m_auxGeometry!.setFromPoints([
                this.points[0],
                this.m_locationObject.position,
              ]);
              this.ellipseOriginRadius = this.points[0].distanceTo(
                this.points[1]
              );
              this.radius = this.points[0].distanceTo(
                this.m_locationObject.position
              );
            } else if (this.points.length > 2) {
              this.radius = length;
            }
            this.updateEllipseGeometry();
          }
          this.view.Render();
          this.angleNum = undefined;
          this.isLineLength = false;
          this.isLineAngle = false;
          this.lineLengthInputValue = "";
          this.isEnter = false;
        }
      }
    }
  }
  onKeyUp(e: KeyboardEvent): void {}

  private get originPoint() {
    return this.points[this.points.length - 1];
  }
  private get curPoint() {
    return this.m_locationObject.position;
  }

  private get curDir() {
    return this.curPoint.clone().sub(this.originPoint).normalize();
  }
  public get Radius() {
    return this.radius;
  }
  public get InputValue() {
    return this.inputValue;
  }
  public get Points() {
    return this.points;
  }
  private radius: number = 0;
  OnZoom(camera: THREE.Camera) {
    this.m_auxPoints = [];
    let scale = this.scale;
    if (this.points.length > 0 && this.points.length < 2) {
      this.m_dimension.Line.SetDimension(
        this.originPoint,
        this.curPoint,
        scale
      );
      this.m_dimension.Arc.SetDimension(
        this.originPoint,
        new THREE.Vector3(1, 0, 0),
        this.curDir,
        scale
      );
    } else {
      this.onMouseMove();
    }
    this.m_dimension.Anchor.SetPoint(this.auxPoint, scale);
    this.m_dimension.OrthogonalAux.visible = false;
    if (this.m_auxOrthogonalOrVertical) {
      this.m_dimension.OrthogonalAux.Set(
        this.m_auxOrthogonalOrVertical.origin,
        this.m_auxOrthogonalOrVertical.dir,
        scale,
        this.m_auxOrthogonalOrVertical.position == IndsertPosition.AuxOrthogonal
          ? undefined
          : this.curPoint
      );
    }
  }
  OnWheel(e: WheelEvent): void {}

  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {
    let tolSq = params.tol * params.tol;

    if (this.points.length > 0) {
      let start = new THREE.Vector3();
      let end = new THREE.Vector3();
      let target = new THREE.Vector3();
      let targetOnSegment = new THREE.Vector3();
      let point = this.points[this.points.length - 1];
      if (this.points.length > 1) {
        for (let index = 0; index < this.points.length - 1; index++) {
          start.copy(this.points[index]);
          end.copy(this.points[index + 1]);
          let distance = params.ray.distanceSqToSegment(
            start,
            end,
            target,
            targetOnSegment
          ); // target在射线上，targetOnSegment在线段上
          //  console.log(target.x,target.y,target.z+'          '+targetOnSegment.x,targetOnSegment.y,targetOnSegment.z)
          if (distance <= tolSq) {
            // let location = {x:Number(target.x.toFixed(3)), y:Number(target.y.toFixed(3)), z:Number(target.z.toFixed(3))};
            let location = {
              x: Number(targetOnSegment.x.toFixed(3)),
              y: Number(targetOnSegment.y.toFixed(3)),
              z: Number(targetOnSegment.z.toFixed(3)),
            };
            let center = new THREE.Vector3(
              (start.x + end.x) * 0.5,
              (start.y + end.y) * 0.5,
              (start.z + end.z) * 0.5
            );
            let d1 = start.distanceTo(targetOnSegment);
            let d2 = center.distanceTo(targetOnSegment);
            let d3 = end.distanceTo(targetOnSegment);
            let position = IndsertPosition.None;
            let min = Math.min(d1, d2, d3);
            let adjust = targetOnSegment.clone();
            if (min <= params.tol) {
              if (min == d1) {
                position = IndsertPosition.Start;
                adjust = start.clone();
              }
              if (min == d2) {
                position = IndsertPosition.Center;
                adjust = center;
              }
              if (min == d3) {
                position = IndsertPosition.End;
                adjust = end.clone();
              }
            }
            let insert = new IndserObject(location, distance, "", []);
            insert.adjust = adjust;
            insert.position = position;
            insert.geo = new THREE.Line3(start.clone(), end.clone());
            params.array.push(insert);
          }
        } // 以上先是用当前移动线检测是否和自己画的线段相交，不包括最后一个线段

        //夹角矫正
        {
          // 这段代码作用为用当前移动线段来和自己画的线的最后一段线检测是否相交
          // alert('yyyyyyyy')
          let direction = new THREE.Vector3();
          this.view.Camera.getWorldDirection(direction);
          let line = new THREE.Line3(
            this.points[this.points.length - 2].clone(),
            this.points[this.points.length - 1].clone()
          );
          let p0 = new THREE.Vector3();
          let p = params.ray.intersectPlane(new THREE.Plane(direction, 0), p0);
          let dir0 = line.end.clone().sub(line.start).normalize();
          let dir1 = p0.clone().sub(line.end).normalize();
          let rad = BPMathUtils.angleTo(dir0, dir1, direction);
          let angle = (rad * 180) / Math.PI;
          let orginLength = p0.distanceTo(line.end);
          let tolAngle = (((params.tol / orginLength) * 180) / Math.PI) * 2; // orginLength越小自动偏转幅度越大

          let offsetAngle = (angle + tolAngle) % 90;
          if (offsetAngle <= tolAngle * 2) {
            //五度之内视为垂直
            rad = rad - ((offsetAngle - tolAngle) * Math.PI) / 180;
            let p = dir0
              .applyAxisAngle(direction, rad)
              .multiplyScalar(p0.distanceTo(line.end));

            p = line.end.clone().add(dir0);
            let insert = new IndserObject(
              p,
              Math.sqrt(params.ray.distanceSqToPoint(p)),
              "",
              []
            );
            insert.adjust = p;
            insert.position = IndsertPosition.AuxOrthogonal;
            params.array.push(insert);
          }
        }
      }
      //正交矫正
      {
        // 这段代码作用为 当只有一个点的时候移动线段和 X轴的相交情况
        let direction = new THREE.Vector3();
        this.view.Camera.getWorldDirection(direction);
        let start = this.points[this.points.length - 1].clone();
        let p0 = new THREE.Vector3();
        params.ray.intersectPlane(new THREE.Plane(direction, 0), p0);
        let dir0 = new THREE.Vector3(1, 0, 0);
        let dir1 = p0.clone().sub(start).normalize();
        let rad = BPMathUtils.angleTo(dir0, dir1, direction);
        let angle = (rad * 180) / Math.PI;
        let orginLength = p0.distanceTo(start);
        let tolAngle = (((params.tol / orginLength) * 180) / Math.PI) * 2;
        let offsetAngle = (angle + tolAngle) % 90;

        if (offsetAngle <= tolAngle * 2) {
          //五度之内视为垂直
          rad = rad - ((offsetAngle - tolAngle) * Math.PI) / 180;
          let p = dir0
            .applyAxisAngle(direction, rad)
            .multiplyScalar(p0.distanceTo(start));
          p = start.clone().add(dir0);
          let insert = new IndserObject(
            p,
            Math.sqrt(params.ray.distanceSqToPoint(p)),
            "",
            []
          );
          insert.adjust = p;
          insert.position = IndsertPosition.AuxOrthogonal;
          // insert.geo = new THREE.Line3(start.clone(), end.clone());
          params.array.push(insert);
        }
      }
    }
    let ray = new THREE.Ray();

    /**
     * 辅助点的吸附点
     */
    if (this.m_auxPoints.length > 0) {
      let normal = new THREE.Vector3(0, 0, 1);
      let panel = new THREE.Plane(normal, 0);
      let insertPoint = new THREE.Vector3();
      params.ray.intersectPlane(panel, insertPoint);

      let func = (line: BPLinear, position: IndsertPosition) => {
        let target = new THREE.Vector3();
        let dis = line.distanceSqPoint(insertPoint, target); //line.distanceSqToRay(params.ray, target);
        if (dis <= tolSq) {
          let insert = new IndserObject(target, Math.sqrt(dis), "", []);
          insert.adjust = target;
          insert.position = position;
          insert.geo = line;
          params.array.push(insert);
        }
      };

      this.m_auxPoints.forEach((item) => {
        if (item.orgin && item.dir) {
          if (
            item.dir.distanceTo(new THREE.Vector3(1, 0, 0)) <= 0.0000001 ||
            item.dir.distanceTo(new THREE.Vector3(-1, 0, 0)) <= 0.0000001 ||
            item.dir.distanceTo(new THREE.Vector3(0, 1, 0)) <= 0.0000001 ||
            item.dir.distanceTo(new THREE.Vector3(0, -1, 0)) <= 0.0000001
          ) {
            func(
              new BPLinear(item.orgin, item.dir),
              IndsertPosition.AuxVertical
            );
            func(
              new BPLinear(
                item.orgin,
                item.dir.clone().applyAxisAngle(normal, Math.PI * 0.5)
              ),
              IndsertPosition.AuxVertical
            );
          } else {
            func(
              new BPLinear(item.orgin, item.dir),
              IndsertPosition.AuxVertical
            );
            func(
              new BPLinear(
                item.orgin,
                item.dir.clone().applyAxisAngle(normal, Math.PI * 0.5)
              ),
              IndsertPosition.AuxVertical
            );
            func(
              new BPLinear(item.orgin, new THREE.Vector3(1, 0, 0)),
              IndsertPosition.AuxOrthogonal
            );
            func(
              new BPLinear(item.orgin, new THREE.Vector3(0, 1, 0)),
              IndsertPosition.AuxOrthogonal
            );
          }
        }
      });
    }

    params.array.forEach((item) => {
      if (item.position == "none") item.position = IndsertPosition.Insert;
      if (item.geo) {
        if (item.geo instanceof THREE.Line3) {
          let line = item.geo as THREE.Line3;
          let p0 = item.adjust ?? item.location;
          let v0 = line.start.clone().sub(line.end.clone());
          let dir0 = v0.clone().normalize();
          if (this.points.length > 0) {
            let point = this.points[this.points.length - 1];
            let v1 = new THREE.Vector3(
              p0.x - point.x,
              p0.y - point.y,
              p0.z - point.z
            );
            let offset = dir0.multiplyScalar(v1.dot(dir0));
            if (offset.lengthSq() <= params.tol * params.tol) {
              //正交矫正
              item.position = IndsertPosition.Vertical;
              item.adjust = new THREE.Vector3(
                p0.x - offset.x,
                p0.y - offset.y,
                p0.z - offset.z
              );
            }
          }
          ray.set(line.start, line.end.clone().sub(line.start).normalize()); // 这里开始检测移动线段是否和场景中两个或两个以上的交点处接触
          params.array.forEach((item1) => {
            if (item1.geo instanceof THREE.Line3) {
              let line1 = item1.geo as THREE.Line3;
              if (
                line != line1 &&
                line.start.clone().distanceTo(line1.start.clone()) >
                  0.0000000001 &&
                line.end.clone().distanceTo(line1.end.clone()) >
                  0.00000000001 &&
                line.start.y != line1.end.y
              ) {
                let target = new THREE.Vector3();
                let target1 = new THREE.Vector3();
                let distance = ray.distanceSqToSegment(
                  line1.start.clone(),
                  line1.end.clone(),
                  target
                );
                if (distance < 0.00000000001) {
                  line.closestPointToPoint(target, true, target1); //
                  if (target.distanceTo(target1) < 0.00000001) {
                    // 说明这两条线交叉了，因为这个点同时在两根线上
                    item.position = IndsertPosition.Cross;
                    item.adjust = target;
                    item.distance = target.distanceTo(
                      new THREE.Vector3(
                        item.location.x,
                        item.location.y,
                        item.location.z
                      )
                    );
                  }
                }
              }
            }
          });
        }
      }
    });
  }
  OnMovePoint(params: DrawOperationMovePointParams): void {
    this.inputValue = "";
    this.m_locationObject.position.copy(params.point);
    this.m_locationObject.visible = true;
    if (this.isDrawEllipseEnd) {
      if (this.m_auxGeometry) {
        this.m_auxGeometry.setFromPoints([this.points[0], params.point]);
        this.m_tempObject!.computeLineDistances();
      }
      let rotate = this.ellipseArcStartRotateAngle();
      let curPoint = this.curPoint.clone();
      curPoint.y -= 10;
      this.inputValue = rotate.toString();
      this.ellipseArcRotateInput?.SetVaule(rotate, curPoint, this.points[0]);
      if (this.isUpdateEllipseArc) {
        // this.updateEllipseGeometry();
        this.updateEllipseArc();
        return;
      }
      return;
    }

    if (params.point.distanceTo(this.m_preMovePoint.point) < this.scale) {
      if (
        params.position == IndsertPosition.End ||
        params.position == IndsertPosition.Start ||
        params.position == IndsertPosition.Center ||
        params.position == IndsertPosition.Cross
      ) {
        if (new Date().getTime() - this.m_preMovePoint.time > 300) {
          //超过1秒 记住锚点
          let dir =
            params.geo && params.geo instanceof THREE.Line3
              ? params.geo.end.clone().sub(params.geo.start).normalize()
              : undefined;
          this.m_auxPoints.push({ orgin: params.point, dir: dir });
        }
      }
    } else {
      this.m_preMovePoint.time = new Date().getTime();
      this.m_preMovePoint.point.copy(params.point);
    }

    this.m_dimension.OrthogonalAux.visible = false;
    if (params.position == IndsertPosition.AuxOrthogonal) {
      let line =
        params.geo instanceof BPLinear
          ? { origin: params.geo.Origin, dir: params.geo.Direction }
          : params.geo instanceof THREE.Line3
          ? {
              origin: params.point,
              dir: params.geo.end.clone().sub(params.geo.start).normalize(),
            }
          : undefined;
      if (line) {
        this.m_dimension.OrthogonalAux.Set(line.origin, line.dir, this.scale);
        this.m_auxOrthogonalOrVertical = {
          position: params.position,
          origin: line.origin,
          dir: line.dir,
        };
      }
    }
    if (params.position == IndsertPosition.AuxVertical) {
      let line =
        params.geo instanceof BPLinear
          ? { origin: params.geo.Origin, dir: params.geo.Direction }
          : params.geo instanceof THREE.Line3
          ? {
              origin: params.point,
              dir: params.geo.end.clone().sub(params.geo.start).normalize(),
            }
          : undefined;
      if (line) {
        this.m_dimension.OrthogonalAux.Set(
          line.origin,
          line.dir,
          this.scale,
          params.point
        );
        this.m_auxOrthogonalOrVertical = {
          position: params.position,
          origin: line.origin,
          dir: line.dir,
        };
      }
    }

    if (this.points.length == 0) return;
    let ps = [];
    ps.push(...this.points);
    ps.push(params.point);
    let paramsClone = params.point.clone();
    paramsClone.sub(this.points[this.points.length - 1].clone()).normalize();
    if (this.isLineAngle) {
      let sub = new THREE.Vector3();
      if (this.isEnter) {
        sub = params.point
          .clone()
          .sub(this.points[this.points.length - 2].clone())
          .normalize();
      } else {
        sub = params.point
          .clone()
          .sub(this.points[this.points.length - 1].clone())
          .normalize();
      }
      let vec1 = new THREE.Vector2(sub.x, sub.y);
      let vec2 = new THREE.Vector2(1, 0);
      let cross = vec1.cross(vec2);
      if (cross > 0) {
        this.angleNum = 360 - this.angleNum!;
      }
      paramsClone = new THREE.Vector3(1, 0, 0);
      paramsClone.applyAxisAngle(
        new THREE.Vector3(0, 0, 1),
        MathUtils.degToRad(this.angleNum! + 0.5)
      );
      let num = 1;
      if (this.isLineLength) {
        num = 2;
      }
      let vertex = ps[ps.length - num].clone();
      let length = vertex.distanceTo(this.points[this.points.length - num]);
      vertex = new THREE.Vector3(
        this.points[this.points.length - num].x + length,
        this.points[this.points.length - num].y,
        0
      );
      vertex.sub(this.points[this.points.length - num].clone());
      vertex.applyAxisAngle(
        new THREE.Vector3(0, 0, 1),
        MathUtils.degToRad(this.angleNum!)
      );
      vertex.add(this.points[this.points.length - num]);
      ps[ps.length - 2] = vertex;
      ps.pop();
      this.points[this.points.length - 1] = vertex;
      this.getRotateAngle();
    }
    if (this.m_auxGeometry) {
      this.m_auxGeometry.setFromPoints([this.points[0], ps[ps.length - 1]]);
      this.m_tempObject!.computeLineDistances();
    } else {
      this.m_tempObject = this.m_model.m_context.ToolsManager.CreatedAuxLine();
      this.m_auxGeometry = this.m_tempObject.geometry;
      this.m_tempObject.frustumCulled = false;
      this.m_auxLayer.add(this.m_tempObject);
    }
    if (this.ellipseObject) {
      if (this.isEllipseOrigin) {
        this.radius = this.ellipseOriginRadius = this.curPoint.distanceTo(
          this.originPoint
        );

        this.m_dimension.Arc.SetDimension(
          ps[ps.length - 2],
          new THREE.Vector3(1, 0, 0),
          paramsClone.clone().normalize(),
          this.scale
        );
      } else {
        this.radius = this.curPoint.distanceTo(this.points[0]);
        this.updateEllipseGeometry();
      }
    }
  }
  private m_ellipseGeometry: THREE.BufferGeometry | undefined;
  private ellipseObject: THREE.LineSegments | undefined;
  private circlePoints: THREE.Vector3[] = [];

  private createEllipse() {
    this.m_ellipseGeometry = new THREE.BufferGeometry();
    this.ellipseObject = new THREE.LineSegments(
      this.m_ellipseGeometry,
      this.m_material
    );
    this.m_auxLayer.add(this.ellipseObject);
  }

  private getStartEllipseArcRadian() {
    let xAxle = new THREE.Vector3()
      .subVectors(this.points[1], this.points[0])
      .normalize();
    let rotate = 0;
    if (xAxle.clone().cross(new THREE.Vector3(0, 1, 0)).z < 0) {
      rotate = THREE.MathUtils.degToRad(Number(this.inputValue)) + Math.PI / 2;
    } else {
      rotate = THREE.MathUtils.degToRad(Number(this.inputValue)) - Math.PI / 2;
    }
    if (rotate > Math.PI * 2) {
      rotate = rotate - Math.PI * 2;
    }
    return rotate;
  }

  private ellipseArcPoints: THREE.Vector2[] = [];
  public updateEllipseGeometry(
    startRotate: number = 0,
    endRotate: number = Math.PI * 2
  ) {
    this.circlePoints.length = 0;
    const arc = new THREE.EllipseCurve(
      this.points[0].x,
      this.points[0].y,
      this.ellipseOriginRadius,
      this.radius,
      startRotate,
      endRotate,
      false,
      this.rotateAngle
    );
    if (this.isDrawEllipseEnd) {
    }
    this.ellipseArcPoints = arc.getPoints(360);
    let points = [...this.ellipseArcPoints];
    for (let i = 0; i < points.length; i++) {
      if (i > 1) {
        if (i % 2 == 0) {
          points.splice(i, 1, points[i - 1], points[i]);
        }
      }
      this.circlePoints.push(new THREE.Vector3(points[i].x, points[i].y, 0));
    }
    this.m_ellipseGeometry!.setFromPoints(this.circlePoints);
    this.m_ellipseGeometry!.attributes.position.needsUpdate = true;
    this.m_ellipseGeometry?.computeBoundingBox();
    this.m_ellipseGeometry?.computeBoundingSphere();
  }

  /**
   * 画椭圆弧
   * @param endRotate
   * @returns
   */
  drawEllipseArc() {
    this.ellipseArcEndPoint = this.curPoint.clone();
    let points = this.ellipseArcPoints;
    this.circlePoints.length = 0;
    let subVec1 = this.curPoint.clone().sub(this.points[0]).normalize();
    this.startEllipseArcRadian = this.getStartEllipseArcRadian();
    let subVec2 = new THREE.Vector3().subVectors(
      this.points[1],
      this.points[0]
    );

    let ray1 = new THREE.Ray(this.points[0], subVec1.clone());
    let optionalPointOnRay = new THREE.Vector3();
    let optionalPointOnSegment = new THREE.Vector3();
    let subVec3 = subVec2.clone();
    subVec3
      .applyAxisAngle(new THREE.Vector3(0, 0, 1), -Math.PI / 2)
      .normalize();
    let ray2 = new THREE.Raycaster(this.points[0], subVec3);
    let insertObject2 = ray2.intersectObject(this.ellipseObject!)[0];
    let distanceArr1 = [];
    let distanceArr2 = [];
    for (let i = 0; i < points.length; i++) {
      let point = new THREE.Vector3(points[i].x, points[i].y, 0);
      if (i === points.length - 1) {
        continue;
      }
      let dis1 = ray1.distanceSqToPoint(
        new THREE.Vector3(points[i].x, points[i].y, 0)
      );
      let dis2 = ray1.distanceSqToPoint(
        new THREE.Vector3(points[i + 1].x, points[i + 1].y, 0)
      );
      distanceArr1.push(dis1 + dis2);
      distanceArr2.push(point.distanceTo(insertObject2!.point));
    }
    let littleDis = Math.min(...distanceArr1);
    let index1 = distanceArr1.indexOf(littleDis);
    ray1.distanceSqToSegment(
      new THREE.Vector3(points[index1].x, points[index1].y, 0),
      new THREE.Vector3(points[index1 + 1].x, points[index1 + 1].y, 0),
      optionalPointOnRay,
      optionalPointOnSegment
    );
    points[index1] = new THREE.Vector2(
      optionalPointOnSegment.x,
      optionalPointOnSegment.y
    );

    let index2 = distanceArr2.indexOf(Math.min(...distanceArr2));
    points[index1] = new THREE.Vector2(
      optionalPointOnSegment!.x,
      optionalPointOnSegment!.y
    );
    points[index2] = new THREE.Vector2(
      insertObject2!.point.x,
      insertObject2!.point.y
    );
    let newPoints1 = points.slice(index1);
    let newPoints2 = points.slice(0, index2);
    let newPoints: THREE.Vector2[] = [];
    if (
      subVec1.clone().dot(subVec2) >= 0 &&
      subVec1.clone().cross(subVec2).z > 0.0000001
    ) {
      newPoints = [...newPoints1, ...newPoints2];
    } else {
      if (
        Math.abs(subVec1.clone().cross(subVec2).z) < 0.0000001 &&
        newPoints1.length > newPoints2.length
      ) {
        newPoints = [...newPoints2];
      } else {
        newPoints = newPoints1.filter((point) => {
          if (newPoints2.includes(point)) {
            return true;
          }
        });
        if (newPoints.length <= 2) {
          newPoints = [...newPoints1, ...newPoints2];
        }
      }
    }
    let ellipseArcPoints = [];
    for (let i = 0; i < newPoints.length; i++) {
      if (i > 1) {
        ellipseArcPoints.push(
          new THREE.Vector3(newPoints[i - 1].x, newPoints[i - 1].y, 0),
          new THREE.Vector3(newPoints[i].x, newPoints[i].y, 0)
        );
      } else {
        ellipseArcPoints.push(
          new THREE.Vector3(newPoints[i].x, newPoints[i].y, 0)
        );
      }
    }
    this.circlePoints = ellipseArcPoints;
    this.m_ellipseGeometry!.setFromPoints(this.circlePoints);
    this.m_ellipseGeometry!.attributes.position.needsUpdate = true;
    this.m_ellipseGeometry?.computeBoundingBox();
    this.m_ellipseGeometry?.computeBoundingSphere();
    this.view.Render();
  }

  updateEllipseArc() {
    let points = [...this.ellipseArcPoints];
    this.circlePoints.length = 0;
    let subVec1 = this.curPoint.clone().sub(this.points[0]).normalize();
    subVec1.z = 0;
    let ray1 = new THREE.Ray(this.points[0], subVec1.clone());
    let optionalPointOnRay = new THREE.Vector3();
    let optionalPointOnSegment = new THREE.Vector3();
    let subVec2 = new THREE.Vector3().subVectors(
      this.ellipseArcEndPoint,
      this.points[0]
    );
    let subVec3 = subVec2.clone().normalize();
    subVec3.z = 0;
    let ray2 = new THREE.Ray(this.points[0], subVec3);
    let distanceArr1 = [];
    let distanceArr2 = [];
    for (let i = 0; i < points.length; i++) {
      if (i === points.length - 1) {
        continue;
      }
      let dis1 = ray1.distanceSqToPoint(
        new THREE.Vector3(points[i].x, points[i].y, 0)
      );
      let dis2 = ray1.distanceSqToPoint(
        new THREE.Vector3(points[i + 1].x, points[i + 1].y, 0)
      );
      distanceArr1.push(dis1 + dis2);

      let dis3 = ray2.distanceSqToPoint(
        new THREE.Vector3(points[i].x, points[i].y, 0)
      );
      let dis4 = ray2.distanceSqToPoint(
        new THREE.Vector3(points[i + 1].x, points[i + 1].y, 0)
      );
      distanceArr2.push(dis3 + dis4);
    }
    let littleDis1 = Math.min(...distanceArr1);
    let index1 = distanceArr1.indexOf(littleDis1);
    ray1.distanceSqToSegment(
      new THREE.Vector3(points[index1].x, points[index1].y, 0),
      new THREE.Vector3(points[index1 + 1].x, points[index1 + 1].y, 0),
      optionalPointOnRay,
      optionalPointOnSegment
    );
    let littleDis2 = Math.min(...distanceArr2);
    let index2 = distanceArr2.indexOf(littleDis2);
    let optionalPointOnRay2 = new THREE.Vector3();
    let optionalPointOnSegment2 = new THREE.Vector3();
    ray2.distanceSqToSegment(
      new THREE.Vector3(points[index2].x, points[index2].y, 0),
      new THREE.Vector3(points[index2 + 1].x, points[index2 + 1].y, 0),
      optionalPointOnRay2,
      optionalPointOnSegment2
    );
    points[index1] = new THREE.Vector2(
      optionalPointOnSegment.x,
      optionalPointOnSegment.y
    );
    points[index2] = new THREE.Vector2(
      optionalPointOnSegment2.x,
      optionalPointOnSegment2.y
    );
    let newPoints1 = points.slice(index2);
    let newPoints2 = points.slice(0, index1 + 1);
    let newPoints: THREE.Vector2[] = [];
    if (
      subVec1.clone().dot(subVec2) >= 0 &&
      subVec1.clone().cross(subVec2).z > 0.0000001
    ) {
      newPoints = [...newPoints1, ...newPoints2];
      if (index1 > index2) {
        newPoints = newPoints1.filter((point) => {
          if (newPoints2.includes(point)) {
            return true;
          }
        });
      }
      if (index1 == index2) {
        // console.log(newPoints1, newPoints2)
        // let point = new THREE.Vector2(
        //   optionalPointOnSegment2.x,
        //   optionalPointOnSegment2.y
        // );
        // let point1 = new THREE.Vector2(
        //   optionalPointOnSegment.x,
        //   optionalPointOnSegment.y
        // );
        // newPoints1[newPoints1.length - 1] = point;
        // newPoints2[newPoints2.length - 1] = point1;
        newPoints = [...newPoints1, ...newPoints2];
        // if(newPoints2.length<newPoints1.length){
        //   newPoints=[...newPoints1]
        // }
      }
    } else {
      if (
        Math.abs(subVec1.clone().cross(subVec2).z) < 0.0000001 &&
        newPoints1.length > newPoints2.length
      ) {
        if (newPoints2.length <= 1) {
          let point = new THREE.Vector2(
            optionalPointOnSegment2.x,
            optionalPointOnSegment2.y
          );

          newPoints = [point, ...newPoints2];
        }
      } else {
        newPoints = newPoints1.filter((point) => {
          if (newPoints2.includes(point)) {
            return true;
          }
        });
        if (newPoints.length == 1) {
          let point = new THREE.Vector2(
            optionalPointOnSegment2.x,
            optionalPointOnSegment2.y
          );
          let point1 = new THREE.Vector2(
            optionalPointOnSegment.x,
            optionalPointOnSegment.y
          );
          newPoints = [point, point1];
        }
        if (!newPoints.length) {
          newPoints = [...newPoints1, ...newPoints2];
        }
      }
    }
    let ellipseArcPoints = [];

    // if (index1 === index2 && subVec1.clone().cross(subVec2).z > 0) {
    //   newPoints = points;
    // }
    for (let i = 0; i < newPoints.length; i++) {
      if (i > 1) {
        ellipseArcPoints.push(
          new THREE.Vector3(newPoints[i - 1].x, newPoints[i - 1].y, 0),
          new THREE.Vector3(newPoints[i].x, newPoints[i].y, 0)
        );
      } else {
        ellipseArcPoints.push(
          new THREE.Vector3(newPoints[i].x, newPoints[i].y, 0)
        );
      }
    }
    this.circlePoints = ellipseArcPoints;
    this.m_ellipseGeometry!.setFromPoints(this.circlePoints);
    this.m_ellipseGeometry!.attributes.position.needsUpdate = true;
    this.m_ellipseGeometry?.computeBoundingBox();
    this.m_ellipseGeometry?.computeBoundingSphere();
    this.view.Render();
  }

  private rotateAngle: number = 0;
  public isUpdateEllipseArc: boolean = false;
  private ellipseObjectClone: THREE.LineSegments | undefined;
  private ellipseArcEndPoint: THREE.Vector3 = new THREE.Vector3();
  OnDownPoint(params: DrawOperationMovePointParams): void {
    if (!this.canDrawCallBack(params)) {
      return;
    }
    if (this.points.length <= 1) {
      this.m_auxPoints = [];
      this.points.push(params.point);
      this.onMouseMove();
    }
    if (this.ellipseOriginRadius !== 0 && !this.isDrawEllipseEnd) {
      this.isEllipseOrigin = false;
      this.getRotateAngle();
      this.m_dimension.Arc.dispose();
      this.updateEllipseGeometry();
    }
    if (this.isDrawEllipseEnd) {
      // this.updateEllipseGeometry();
      this.drawEllipseArc();
      this.isUpdateEllipseArc = true;
    }
  }
  GetPoints(): Vector3[] {
    return this.points;
  }
  getRotateAngle() {
    let subVec1 = new THREE.Vector3().subVectors(
      this.points[1],
      this.points[0]
    );
    let xVector = new THREE.Vector3(1, 0, 0);
    if (this.points[1].y >= this.points[0].y) {
      this.rotateAngle = subVec1.angleTo(xVector);
    } else {
      this.rotateAngle = Math.PI * 2 - subVec1.angleTo(xVector);
    }
  }

  get auxPoint() {
    let ps: THREE.Vector3[] = [];
    this.m_auxPoints.forEach((x) => {
      ps.push(x.orgin);
    });
    return ps;
  }

  // 完成椭圆绘制
  public isDrawEllipseEnd: boolean = false;
  finishEllipse() {
    if (this.isDrawEllipseEnd) return;
    this.isDrawEllipseEnd = true;
    if (this.m_dimension) {
      this.m_dimension.Line.dispose();
      if (this.points.length == 1) {
        this.m_dimension.Arc.dispose();
      }
    }
    this.createEllipseArcRotateInput();
    let rotate = this.ellipseArcStartRotateAngle();
    let curPoint = this.curPoint.clone();
    curPoint.y -= 10;
    this.ellipseArcRotateInput?.SetVaule(rotate, curPoint, this.points[0]);
    this.inputValue = rotate;
    let geoClone = this.m_ellipseGeometry!.clone();
    this.ellipseObjectClone = new THREE.LineSegments(
      geoClone,
      this.m_material.clone()
    );
    this.ellipseObjectClone.visible = false;
    this.m_auxLayer.add(this.ellipseObjectClone);
    // this.ellipseOriginRadius = 0;
  }

  ellipseArcStartRotateAngle(): string {
    let subVec = new THREE.Vector3().subVectors(this.points[1], this.points[0]);
    subVec.applyAxisAngle(new THREE.Vector3(0, 0, 1), -Math.PI / 2);
    let subVec1 = new THREE.Vector3().subVectors(this.curPoint, this.points[0]);
    let rotate = MathUtils.radToDeg(subVec.angleTo(subVec1));
    if (subVec1.cross(subVec).z > 0) {
      rotate = 360 - rotate;
    }
    return rotate.toFixed(0).toString();
  }
  private ellipseArcRotateInput: UInput | undefined;
  createEllipseArcRotateInput() {
    this.ellipseArcRotateInput = new UInput(this.view, this.view.m_context.Dom);
    this.ellipseArcRotateInput.Dom.style.border = "2px solid #fff";
  }

  Finish(operate: DrawOperateState): EllipseArcReturnData | undefined {
    if (this.m_tempObject) this.m_auxLayer.remove(this.m_tempObject);
    if (this.m_auxGeometry) this.m_auxGeometry.dispose();
    if (this.m_locationObject) {
      this.m_auxLayer.remove(this.m_locationObject);
      this.m_locationObject.geometry.dispose();
    }
    if (this.ellipseObject) {
      this.m_auxLayer.remove(this.ellipseObject);
      this.ellipseObject.geometry.dispose();
    }
    if (this.ellipseObjectClone) {
      this.m_auxLayer.remove(this.ellipseObjectClone);
      this.ellipseObjectClone.geometry.dispose();
    }
    if (this.ellipseArcRotateInput) {
      this.ellipseArcRotateInput.dispose();
    }
    this.ellipseOriginRadius = 0;
    if (operate == DrawOperateState.complete) {
      this.endEllipseArcRadian = this.getStartEllipseArcRadian();
      if (this.circlePoints.length > 1) {
        let key = `${this.m_layer.Id}_${this.m_layer.Color}`;
        let lines: DbLine[] = this.m_model.Lines[key]?.lines ?? [];
        let ps: number[] = [];
        let index = 0;
        let indexs: number[] = [];
        let returnLine: EllipseArcReturnData;
        this.circlePoints.forEach((p) => {
          ps.push(p.x, p.y, p.z);
          indexs.push(index);
          if (index != 0 && index != this.circlePoints.length - 1)
            indexs.push(index);
          index++;
        });

        let line = new DbLine({
          id: generateUUID(),
          layerId: this.m_layer.Id,
          blockId: "",
          points: new Float32Array(ps),
          indexes: new Int32Array(indexs),
          color: this.m_layer.Color,
        });
        let sphere = new THREE.Sphere();
        let box = new THREE.Box3();
        box.setFromArray(line.points);
        box.getBoundingSphere(sphere);
        line.block_path = generateUUID();
        line.sphere = sphere;
        line.box = box;
        line.extend_id = generateUUID();
        lines.push(line);
        let longVector = new THREE.Vector3()
          .subVectors(this.points[1], this.points[0])
          .normalize();
        let longLength = new THREE.Vector3()
          .subVectors(this.points[1], this.points[0])
          .length();
        let shortVector = longVector.clone();
        shortVector.applyAxisAngle(new THREE.Vector3(0, 0, 1), Math.PI / 2);
        returnLine = {
          center: {
            x: sphere.center.x,
            y: sphere.center.y,
            z: sphere.center.z,
          },
          longVector,
          longLength,
          shortVector,
          shortLength: this.radius,
          startRadian: this.startEllipseArcRadian,
          endRadian: this.endEllipseArcRadian,
        };
        if (this.m_layer.Color) {
          if (this.m_layer.Objects.length >= 1) {
            let lastObj = this.m_layer.Objects.pop();
            this.m_model.Model.remove(lastObj!);
          }
          if (this.m_model.Lines[key]) {
            this.m_model.Lines[key].lines = lines;
            this.view.m_context.ToolsManager.LinesToModel(
              lines,
              this.m_model.Lines[key].model
            );
          } else {
            this.m_model.Lines[key] = {
              canEdit: true,
              lines: lines,
              model: this.m_model.addLinesToModel(
                this.m_layer.Id,
                this.m_layer.Color,
                lines
              ),
            };
          }
        }
        return returnLine;
      }
    } else if (operate == DrawOperateState.cancel) {
      return undefined;
    }
    return undefined;
  }

  private get scale() {
    return this.view.ScreenModelScale;
  }
}

class DimensionGroup {
  private m_dimension: LineDimension;
  private m_arcDimension: ArcDimension;
  private m_anchor: AnchorPointAux; // 十字mesh
  private m_orthogonalAux: OrthogonalAux;
  constructor(view: ViewManager, root: THREE.Object3D) {
    this.m_arcDimension = new ArcDimension(view, root);
    this.m_dimension = new LineDimension(view, root);
    this.m_anchor = new AnchorPointAux(view, root);
    this.m_orthogonalAux = new OrthogonalAux(view, root);
  }

  public get Line() {
    return this.m_dimension;
  }

  public get Arc() {
    return this.m_arcDimension;
  }
  public get Anchor() {
    return this.m_anchor;
  }

  public get OrthogonalAux() {
    return this.m_orthogonalAux;
  }

  public dispose() {
    if (this.Line) this.Arc.dispose();
    if (this.Line) this.Line.dispose();
    if (this.m_anchor) this.m_anchor.dispose();
    if (this.m_orthogonalAux) {
      this.m_orthogonalAux.dispose();
    }
  }
}

export { DrawOperationEllipseArc, DrawOperateLineParams, EllipseArcReturnData };
